const RegexDetectionSettings = {
  email: true,
  phone: true,
  username: true,
  address: true,
  website: false,
  violationWords: true,
};

const emailRegex = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi;
const phoneRegex = /\+?1?[-.\s()]?\(?\d{3}\)?[-.\s()]?\d{3}[-.\s.]?\d{4}/g;
const userNameRegex = /@([a-z0-9_]+)/i;
const addressRegex = /\b(?:\d{1,5}\s(?:[A-Za-z0-9#.,\-]+ ){0,5}(?:Street|St|Avenue|Ave|Road|Rd|Boulevard|Blvd|Lane|Ln|Drive|Dr|Dr.|Court|Ct|Trail|Trl|Parkway|Pkwy|Way|Place|Pl|Square|Sq|Loop|Terrace|Ter|Highway|Hwy|Circle|Cir)\b(?:\s(?:[A-Za-z#.,\-]+)){0,3}?,?\s?(?:Apt|Unit|Suite|Ste|Bldg|Fl|Floor|#)?\s?\d{0,6}?|(?:PO Box|P\.O\. Box|RR \d+ Box \d+))\s?,?\s?[A-Za-z\s]+,?\s?(?:AL|AK|AZ|AR|CA|CO|CT|DE|FL|GA|HI|ID|IL|IN|IA|KS|KY|LA|ME|MD|MA|MI|MN|MS|MO|MT|NE|NV|NH|NJ|NM|NY|NC|ND|OH|OK|OR|PA|RI|SC|SD|TN|TX|UT|VT|VA|WA|WV|WI|WY)\s\d{5}(-\d{4})?\b/g;
const websiteLinkRegex = /(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/gm;
const violationWords = /^payment|pay|deposit|transfer|email|instagram|facebook|call|phone|address|location|business name|what's your number|postal|zip|code$/;

export class ContactInfoDetectorUtil {
  static hashContactInfo(msg) {
    let hashedMessage = msg;
    if (RegexDetectionSettings.email)
      hashedMessage = hashedMessage.replace(emailRegex, ` (email hidden)`);
    if (RegexDetectionSettings.phone)
      hashedMessage = hashedMessage.replace(phoneRegex, ` (phone number hidden)`);
    if (RegexDetectionSettings.username)
      hashedMessage = hashedMessage.replace(userNameRegex, ` (username hidden)`);
    if (RegexDetectionSettings.address)
      hashedMessage = hashedMessage.replace(addressRegex, ` (address hidden)`);
    if (RegexDetectionSettings.website)
      hashedMessage = hashedMessage.replace(websiteLinkRegex, ` (website hidden)`);

    return hashedMessage;
  }

  static detectMessageViolations(message) {
    const detectedArr = [];
    if (emailRegex.test(message) && RegexDetectionSettings.email) {
      //   console.log(`message.match(emailRegex)`, message.match(emailRegex));
      detectedArr.push(message.match(emailRegex)?.[0]);
    }
    if (phoneRegex.test(message) && RegexDetectionSettings.phone) {
      //   console.log(`message.match(phoneRegex)`, message.match(phoneRegex));
      detectedArr.push(message.match(phoneRegex)?.[0]);
    }
    if (userNameRegex.test(message) && RegexDetectionSettings.username) {
      //   console.log(`message.match(userNameRegex)`, message.match(userNameRegex));
      detectedArr.push(message.match(userNameRegex)?.[0]);
    }
    if (addressRegex.test(message) && RegexDetectionSettings.address) {
      //   console.log(`message.match(addressRegex)`, message.match(addressRegex));
      detectedArr.push(message.match(addressRegex)?.[0]);
    }
    if (websiteLinkRegex.test(message) && RegexDetectionSettings.website) {
      //   console.log(`message.match(websiteLinkRegex)`, message.match(websiteLinkRegex));
      detectedArr.push(message.match(websiteLinkRegex)?.[0]);
    }
    if (violationWords.test(message) && RegexDetectionSettings.violationWords) {
      //   console.log(`message.match(violationWords)`, message.match(violationWords));
      detectedArr.push(message.match(violationWords)?.[0]);
    }
    // console.log(`detectedArr`, detectedArr);
    return detectedArr.length > 0;
  }
}
